import { Typography } from "@mui/material";
import React from "react";
import { useState } from "react";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { adminUserListAction } from "../../redux/actions/capitalAction";
import MUITable from "./MUITable";

const UserListPage = () => {
  const { loading, data:useData, msg, error } = useSelector((state) => state.adminUserListReducer);
  const dispatch = useDispatch();

  const [TableHead, setTableHead] = useState(null);
  const [TableRow, setTableRow] = useState(null);

  const [checked, setChecked] = React.useState({});
  useEffect(() => {
    if(loading){
      dispatch(adminUserListAction())
    }
    if(!loading){
      // console.log(data)
      const header = [
        {
            id: 'name',
            label: 'Name',
            sticky: false,
            format: (value) => value.toLocaleString('en-US'),
            minWidth: 120
        },
        {
            id: 'email',
            label: 'Email',
            sticky: false,
            format: (value) => value.toLocaleString('en-US'),
            minWidth: 120
        },
        {
            id: 'mobile',
            label: 'Mobile',
            sticky: false,
            format: (value) => value.toLocaleString('en-US'),
            minWidth: 120
        },
        {
            id: 'type',
            label: 'User Type',
            sticky: false,
            format: (value) => value.toLocaleString('en-US'),
            minWidth: 120
        },
        {
            id: 'is_vdr',
            label: 'VDR Access',
            sticky: false,
            format: (value) => value.toLocaleString('en-US'),
            minWidth: 120
        },
        // {
        //     id: 'action',
        //     label: 'Action',
        //     sticky: false,
        //     minWidth: 120
        // },
      ];
      let arr = [];
      
      let isVdr = {};
      useData.map((item)=>{
        isVdr = { ...isVdr, [item.email]: item.is_vdr}
      });
      setChecked(isVdr);
      setTableRow(useData);
      setTableHead(header);
    }
  }, [dispatch, loading]);

  return (
    <>
      <div>
        <Typography variant="h5" sx={{ fontWeight: "600" }}>
          Users
        </Typography>
        <hr />
      </div>

      <div>
        <MUITable tableColumns={TableHead} tableRows={TableRow}  checked={checked} setChecked={setChecked} />
      </div>
    </>
  );
};

export default UserListPage;
